import { StreamActions, StreamElement } from '@hotwired/turbo'
import { FetchRequest } from '@rails/request.js'

// Handles the `fetch_stream` tag. Makes each target element perform a fetch request to the URL specified in `data-fetch-stream-url`.
// `this: StreamElement` is the streamed <turbo-stream> element, the tag doesn't carry any markup:
// <turbo-stream action="fetch_stream" targets="<unique_selector>"><template></template></turbo-stream>
StreamActions.fetch_stream = function (this: StreamElement) {
  this.targetElements.forEach(element => {
    const fetchStreamUrl = (element as HTMLElement).dataset.fetchStreamUrl

    if (!fetchStreamUrl) {
      console.warn('fetch_stream target is missing data-fetch-stream-url')
      return
    }

    new FetchRequest('get', fetchStreamUrl, { responseKind: 'turbo-stream' }).perform()
  })
}
